import { ReactNode, useCallback } from 'react'
import tw from 'twin.macro'
import { ReactComponent as BackgroundImage } from 'src/assets/images/background.svg'
import { Settings } from 'src/components/settings/Settings'
import { useSelector } from 'react-redux'
import { Button } from 'src/components/shared/Button'
import { ChatMajor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { useMediaQueries } from 'src/hooks/useMediaQueries'
import { getPartner } from 'src/selectors/partner'

interface Props {
  children: ReactNode
  isHeaderShown?: boolean
}

export const ContractorPortalSecureWrapper = ({ children, isHeaderShown = true }: Props) => {
  const partner = useSelector(getPartner)

  const { isMobile, isDesktopOrTablet, isTablet } = useMediaQueries()

  const handleGetHelp = useCallback(() => {
    showIntercom()
  }, [])

  return (
    <div css={tw`h-full w-full flex flex-col`}>
      {isHeaderShown && (
        <div
          css={tw`bg-primary-700 w-full h-16 p-4 shadow top-0 flex justify-between items-center fixed z-20`}
        >
          <img src={partner?.logoUrl} css={tw`h-[28px]`} />
          <div css={tw`flex-row flex gap-2`}>
            {!isTablet && (
              <Button
                className={tw`w-[120px] px-3`}
                rightIcon={
                  isMobile && <QuestionMarkMajor css={tw`fill-shades-0`} width={20} height={20} />
                }
                leftIcon={
                  isDesktopOrTablet && <ChatMajor css={tw`fill-shades-0`} width={20} height={20} />
                }
                onClick={handleGetHelp}
                color={isDesktopOrTablet ? 'dark' : 'primary'}
                size="medium"
              >
                Get Help
              </Button>
            )}
            <Settings flow="contractorPortal" />
          </div>
        </div>
      )}
      <div css={tw`flex flex-1 bg-primary-800 items-center justify-center flex-col lg:py-16`}>
        <BackgroundImage css={tw`fixed top-0 bottom-0 z-0 h-full [&>path]:fill-primary-900`} />
        <div
          css={tw`bg-shades-0 sm:max-w-[390px] mx-4 sm:min-h-[80vh] w-full flex flex-1 sm:flex-none flex-col sm:rounded-2xl overflow-hidden z-10 sm:my-4`}
        >
          <div css={tw`flex flex-1 bg-shades-50 items-center flex-col`}>{children}</div>
        </div>
      </div>
    </div>
  )
}
